import { Button, Input, Select, Table } from 'antd';
import { Option } from 'antd/es/mentions';
import React, { useState ,useEffect } from 'react'
import "../../MainCSS.css";
import axios from 'axios';
import { toast } from 'react-toastify';
import "aos/dist/aos.css";
import { DeleteBankDetailsMaster, GetBankDetailsMaster, SaveBankDetailsMaster, UpdateBankDetailsMaster } from '../../../AllAPI/MasterAPI/GeneralMasterApi';


const BankDetailsMaster = () => {

   const userData = sessionStorage.getItem('authToken');
  const userId = sessionStorage.getItem('userId');
  const authHeaders = sessionStorage.getItem('authHeaders');
  const headersObj = JSON.parse(authHeaders).headers;

  
  const userIp = headersObj.userIp
  const deviceSign = headersObj.deviceSign
  const userLong = headersObj.userLong
  const userLat = headersObj.userLat

  const commonHeaders = {
    headers: {
      createdBy: userId,
      updatedBy: userId,
      userIp: userIp,
      userLat: userLat,
      userLong: userLong,
      deviceSign: deviceSign,
    },
  };



    const [errors, setErrors] = useState({
      bankName: "",
      branchName: "",
      accountNumber:"",
      ifscCode:"",
    });
  
    const [pageSize, setPageSize] = useState(10);
    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalEntries, setTotalEntries] = useState(0);
    const [bankDetailId, setBankDetailId] = useState("");
    const [bankName, setBankName] = useState("");
    const [branchName, setBranchName] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [ifscCode, setIfscCode] = useState("");

    const [allBank, setAllBank] = useState([]);
    const [submitButton, setSubmitButton] = useState(true);
    const [updateButton, setUpdateButton] = useState(false);
  
    //======Search data from table===============
    const handleSearch = (value) => {
      const searchValue = value.toLowerCase();
    
      const filtered = allBank.filter((item) =>
        Object.values(item).some((val) =>
          String(val ?? "").toLowerCase().includes(searchValue)
        )
      );
    
      setFilteredData(filtered);
      setTotalEntries(filtered.length);
      setCurrentPage(1);
    };
    //==========Pagination=======================
    const handlePageSizeChange = (value) => {
      setPageSize(value);
    };
  
    // ==============Get table data================
  let isBankDetailMasterFetched = false;
  useEffect(() => {
    if (isBankDetailMasterFetched) return;
        fetchBankDetailMaster();
    isBankDetailMasterFetched = true;
  }, []);

  let isError = false;

  const fetchBankDetailMaster = async () => {
    try {
       const response = await axios.get(GetBankDetailsMaster ,commonHeaders);
   
      if (response.data !== null) {
        setAllBank(response.data);
        setFilteredData(response.data); // Set initial filtered data as the fetched data
        setTotalEntries(response.data.length); // Set the total number of entries
      }
    } catch (error) {
      if (!isError) {
        console.error("Error fetching Bank Detail Master data:", error);
        toast.error("Failed to fetch Bank Detail Master data");
        isError = true; // Set the flag to prevent double toast
      }
    }
  };
  
    // const columns = [
    //   {
    //     title: "Sr.No.",
    //     dataIndex: "",
    //     key: "index",
    //     render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    //   },
    
    //   {
    //     title:"Bank Name",
    //     dataIndex: "bankName",
    //     key: "bankName",
    //   },
    //   {
    //     title: "Branch Name",
    //     dataIndex: "branch",
    //     key: "branch",
    //   },
    //   {
    //     title: "Account Number",
    //     dataIndex: "accNumber",
    //     key: "accNumber",
    //   },
    //   {
    //     title: "IFSC Code",
    //     dataIndex: "ifscCode",
    //     key: "ifscCode",
    //   },
    //   {
    //     title: "Actions",
    //     key: "actions",
    //     render: (text, record) => (
    //       <div>
    //         <span
    //           type="submit"
    //           style={{ fontSize: "12px", color: "#349ff3", marginRight: "10px" }}
    //           onClick={() => handleEditDataButton(record)}
    //         >
    //           <i class="fa-solid fa-pen-to-square"></i>
    //         </span>
    //         <span
    //           type="submit"
    //           style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
    //           onClick={() => handleDeleteData(record)}
    //         >
    //           <i class="fa-solid fa-trash"></i>
    //         </span>
    //       </div>
    //     ),
    //   },
    // ];
  

    const columns = [
  {
    title: "Sr.No.",
    dataIndex: "",
    key: "index",
    render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Bank Name",
    dataIndex: "bankName",
    key: "bankName",
    sorter: (a, b) => {
      // Sorting by string value (alphabetical order)
      return String(a.bankName).localeCompare(String(b.bankName));
    },
  },
  {
    title: "Branch Name",
    dataIndex: "branch",
    key: "branch",
    sorter: (a, b) => {
      // Sorting by string value (alphabetical order)
      return String(a.branch).localeCompare(String(b.branch));
    },
  },
  {
    title: "Account Number",
    dataIndex: "accNumber",
    key: "accNumber",
    sorter: (a, b) => {
      // Sorting by string value (account numbers can be treated as strings)
      return String(a.accNumber).localeCompare(String(b.accNumber));
    },
  },
  {
    title: "IFSC Code",
    dataIndex: "ifscCode",
    key: "ifscCode",
    sorter: (a, b) => {
      // Sorting by string value (alphabetical order)
      return String(a.ifscCode).localeCompare(String(b.ifscCode));
    },
  },
  {
    title: "Actions",
    key: "actions",
    render: (text, record) => (
      <div>
        <span
          type="submit"
          style={{ fontSize: "12px", color: "#349ff3", marginRight: "10px" }}
          onClick={() => handleEditDataButton(record)}
        >
          <i class="fa-solid fa-pen-to-square"></i>
        </span>
        <span
          type="submit"
          style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
          onClick={() => handleDeleteData(record)}
        >
          <i class="fa-solid fa-trash"></i>
        </span>
      </div>
    ),
  },
    ];

    const components = {
      header: {
        cell: ({ children, ...restProps }) => (
          <th
            {...restProps}
            style={{
              backgroundColor: "#023e7d",
              color: "#fff",
              padding: "10px",
              fontSize: "13px",
              borderRadius: "0px",
            }}
          >
            {children}
          </th>
        ),
      },
      body: {
        row: ({ children, ...restProps }) => (
          <tr
            {...restProps}
            style={{
              backgroundColor: "#f0f7fd",
            }}
          >
            {children}
          </tr>
        ),
        cell: ({ children, ...restProps }) => (
          <td
            {...restProps}
            style={{
              padding: "8px",
            }}
          >
            {children}
          </td>
        ),
      },
    };
    // ========Submit data to table==============
        const handleSubmit = async () => {
          let isValid = true;
          const errorObj = {};
      
          if (!bankName.trim()) {
            isValid = false;
            errorObj.bankName = "bankName is required *";
          }
          
          if (!branchName.trim()) {
            isValid = false;
            errorObj.branchName = "BranchName is required *";
          }
          if (!accountNumber.trim()) {
            isValid = false;
            errorObj.accountNumber = "Account Number is required *";
          }
            if (!ifscCode.trim()) {
            isValid = false;
            errorObj.ifscCode = "IFSC Code  is required *";
          }
          if (!/^\d+$/.test(accountNumber)) {
            toast.warn( "Account number must be numeric");
             return;
          }

          setErrors(errorObj); // Set error messages
      
          if (!isValid) return;
      
          const bodyData = {
            bankName: bankName,
            branch:branchName,
            accNumber:accountNumber,
            ifscCode:ifscCode,
   
          };
      
          try {
             const response = await axios.post(SaveBankDetailsMaster, bodyData ,commonHeaders);
  
            if (response.data === "CREATED") {
              toast.success("Bank Detail added successfully!");
              fetchBankDetailMaster();
              handleCancel();
            } else if (response.data === "ALREADYEXISTED") {
              toast.warn("Bank Detail already exist!");
                           //handleCancel();
            }
          } catch (error) {
            console.error("Error during API call:", error);
            toast.error("Error occurred while submitting data");
          }
        };
    //==================== Handle Cancel button =====================
        const handleCancel = () => {
          setUpdateButton(false);
          setSubmitButton(true);
          setBranchName("");
          setBankName("");
          setAccountNumber("");
          setIfscCode("");
          setErrors("");
          
        };
      // ========Update data from table============
      const handleEditDataButton = (item) => {
        setUpdateButton(true);
        setSubmitButton(false);
        window.scrollTo(0, 0);
        setBankName(item.bankName);
        setBranchName(item.branch);
      setAccountNumber(item.accNumber);
      setIfscCode(item.ifscCode);
        setBankDetailId(item.id);
      };
      const handleUpdate = async () => {
        if (!bankName) {
          toast.warn("Please enter Bank Name!");
          return;
        }
        if (!branchName) {
          toast.warn("Please enter Branch Name!");
          return;
        }
    
        if (!accountNumber) {
          toast.warn("Please enter Account Number!");
          return;
        }
        if (!ifscCode) {
          toast.warn("Please enter IFSC Code!");
          return;
        }
        if (!/^\d+$/.test(accountNumber)) {
          toast.warn( "Account number must be numeric");
          return;
          
        }
       
        const bodyData = {
          id:bankDetailId,
          bankName: bankName,
          branch:branchName,
          accNumber:accountNumber,
          ifscCode:ifscCode,
        };
    
        try {
         const response = await axios.put(UpdateBankDetailsMaster, bodyData ,commonHeaders
         );
          if (response.data === "UPDATED") {
            toast.success("Bank Detail updated successfully!");
            fetchBankDetailMaster();
            handleCancel();
          } else if (response.data === "ALREADYEXISTED") {
            toast.warn("Bank Detail already exist!");
                          //handleCancel();

          }
        } catch (error) {
          console.error("Error during API call:", error);
          toast.error("Error occurred while updating data");
        }
      };
      //============================== Delete data from table ======================================
      const handleDeleteData = async (item) => {
        const confirmDelete = window.confirm(
          `Are you sure you want to delete the BankName  "${item.bankName}"?`
        );
        if (!confirmDelete) return;
    
        try {
          const response = await axios.delete(
            `${DeleteBankDetailsMaster}?id=${item.id}`,commonHeaders
          );
       
          if (response.data === "DELETED") {
            toast.success("Bank Detail deleted successfully!");
            fetchBankDetailMaster();
            handleCancel();
          }
        } catch (error) {
          console.error("Error during delete operation:", error);
          toast.error("Error occurred while deleting ");
        }
      };
  return (
    <div className="px-5 py-3">
        <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
            <div className="col-12">
              <div className="row px-md-5 mt-3 p-2 ">
        
                <div className="row p-0 m-0">
        <div className="col-12 col-lg-4"></div>
        <div className="col-12 col-lg-4">
        <div className="row p-0 m-0">
          
                <div className="col-12 py-1">
                  <label className="labels">Bank Name</label>
                  <Input
                    value={bankName}
                    onChange={(e) => setBankName(e.target.value)}
                    placeholder="Enter Name"
                    maxLength="250"
                    style={{ width: '100%' }}
                  />
                  {errors.bankName && <div className="errorField">{errors.bankName}</div>}
                </div>
          
                <div className="col-12 py-1">
                  <label className="labels">Branch Name</label>
                  <Input
                    value={branchName}
                    maxLength="250"
                    onChange={(e) => setBranchName(e.target.value)}
                    placeholder="Enter Branch Name"
                    style={{ width: '100%' }}
                  />
                  {errors.branchName && <div className="errorField">{errors.branchName}</div>}
                </div>
                <div className="col-12 py-1">
                  <label className="labels">Account Number</label>
                  <Input type='tel'
                    value={accountNumber}
                    maxLength="15"
                    onChange={(e) => setAccountNumber(e.target.value)}
                    placeholder="Enter Account Number"
                    style={{ width: '100%' }}
                  />
                  {errors.accountNumber && <div className="errorField">{errors.accountNumber}</div>}
                </div>
                <div className="col-12 py-1">
                  <label className="labels">IFSC Code</label>
                  <Input
                    value={ifscCode}
                    maxLength="11"
                    onChange={(e) => setIfscCode(e.target.value)}
                    placeholder="Enter IFSC code"
                    style={{ width: '100%' }}
                  />
                  {errors.ifscCode && <div className="errorField">{errors.ifscCode}</div>}
                </div>
                </div>
                </div>
                </div>
            
                
                    <div className="col-12 text-center pt-3">
                      <Button
                        type="submit"
                        className="CancelBtn mx-1"
                        onClick={handleCancel}
                      >
                        Cancel
                      </Button>
                      {submitButton && (
                        <Button
                          type="submit"
                          className="SubmitBtn mx-1"
                          onClick={handleSubmit}
                        >
                          Submit
                        </Button>
                      )}
                      {updateButton && (
                        <Button
                          type="submit"
                          className="UpdateBtn mx-1"
                          onClick={handleUpdate}
                        >
                          Update
                        </Button>
                      )}
                    </div>
            
              
            
              <div className="col-12 p-0 mt-3" style={{ borderBottom: "2px solid #bfb597" }}></div>
              </div>
            
              {/*================ Table =========================*/}
              <div className="row m-0 p-2 px-md-5 pt-md-0 mt-3">
                <div className="col-12 py-3 shadow border" style={{ backgroundColor: "white" }}>
                  <div className="col-12 px-md-5" style={{ display: "flex", justifyContent: "space-between" }}>
                    <div>
                      <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                      <Select
                        defaultValue={pageSize}
                        onChange={handlePageSizeChange}
                        style={{ width: 120, textAlign: "center" }}
                      >
                        <Option value={10}>10</Option>
                        <Option value={20}>20</Option>
                        <Option value={30}>30</Option>
                      </Select>
                    </div>
            
                    <div className="pt-4 pt-md-0">
                      <Input.Search
                        placeholder="Search"
                        onChange={(e) => handleSearch(e.target.value)}
                        style={{ width: 200, marginBottom: 16 }}
                      />
                    </div>
                  </div>
            
                  <div style={{ backgroundColor: "white" }}>
                    <Table
                      bordered
                      style={{ padding: "0px 20px", overflowX: "auto" }}
                      columns={columns}
                      dataSource={filteredData}
                      pagination={{
                        pageSize: pageSize,
                        total: totalEntries,
                        showTotal: (total, range) =>
                          `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                        current: currentPage,
                        onChange: (page) => setCurrentPage(page),
                      }}
                      showSorterTooltip={false}
                      rowKey={(record) => record.id}
                      components={components}
                    />
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
  )
}

export default BankDetailsMaster